module.exports = __webpack_public_path__ + "img/emoji-satisfied.b64b1350.svg";